import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import H2 from '../H2';

const CustomH2 = styled(H2)`
  ${tw`text-left p-0 mt-0 sm:mt-0 sm:mb-gutter`};
`;

export { CustomH2 };
